import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
const Gear = ({ style })=>{
    return /*#__PURE__*/ _jsx("div", {
        style: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: style.fontSize,
            height: style.fontSize
        },
        children: /*#__PURE__*/ _jsxs("svg", {
            height: style.fontSize,
            width: style.fontSize,
            viewBox: "0 0 16 16",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ _jsx("title", {
                    children: "grid interface"
                }),
                /*#__PURE__*/ _jsxs("g", {
                    fill: "currentColor",
                    children: [
                        /*#__PURE__*/ _jsx("path", {
                            d: "M6,0H1C0.4,0,0,0.4,0,1v5c0,0.6,0.4,1,1,1h5c0.6,0,1-0.4,1-1V1C7,0.4,6.6,0,6,0z",
                            fill: "currentColor"
                        }),
                        /*#__PURE__*/ _jsx("path", {
                            d: "M15,0h-5C9.4,0,9,0.4,9,1v5c0,0.6,0.4,1,1,1h5c0.6,0,1-0.4,1-1V1C16,0.4,15.6,0,15,0z"
                        }),
                        /*#__PURE__*/ _jsx("path", {
                            d: "M6,9H1c-0.6,0-1,0.4-1,1v5c0,0.6,0.4,1,1,1h5c0.6,0,1-0.4,1-1v-5C7,9.4,6.6,9,6,9z"
                        }),
                        /*#__PURE__*/ _jsx("path", {
                            d: "M15,9h-5c-0.6,0-1,0.4-1,1v5c0,0.6,0.4,1,1,1h5c0.6,0,1-0.4,1-1v-5C16,9.4,15.6,9,15,9z",
                            fill: "currentColor"
                        })
                    ]
                })
            ]
        })
    });
};
export default Gear;
